export default {
  counter: {
    our_impact: "تأثيرنا",
    trusted_by: "موثوق من قبل",
    growing_businesses: "شركات متنامية",

    happy_restaurants: "مطاعم سعيدة",
    verified_suppliers: "موردون معتمدون",
    industry_awards: "جوائز صناعية",
    average_rating: "متوسط التقييم",
  },
};